import { createStore } from 'redux';
import rootReducer from '../reducers/rootReducer';
// for chrome extension - redux devtools extension
import {composeWithDevTools} from 'redux-devtools-extension';

const configureStore = () => createStore(rootReducer, composeWithDevTools());

export default configureStore;